import axios from "axios";
import qs from "query-string";
const axiosInstance = axios.create({
  baseURL: "",
  timeout: 600000,
});
export default {
  sendHelperCommand: (helperAspx, params) =>
    new Promise(async (resolve, reject) => {
      try {
        const strParam = qs.stringify(params);
        const helperGetData = await axiosInstance.get(
          `${helperAspx}?${strParam}`
        );
        if (helperGetData.data.ErrorMessage) {
          reject(new Error(helperGetData.data.ErrorMessage));
        } else {
          resolve(helperGetData.data.result);
        }
      } catch (err) {
        reject(err);
      }
    }),
  sendHelperCommandPost: (helperAspx, params) =>
    new Promise(async (resolve, reject) => {
      try {
        const helperGetData = await axiosInstance.post(helperAspx, params);
        if (helperGetData.data.ErrorMessage) {
          reject(new Error(helperGetData.data.ErrorMessage));
        } else {
          resolve(helperGetData.data.result);
        }
      } catch (err) {
        reject(err);
      }
    }),
  sendCommand: (commandName, params) =>
    new Promise(async (resolve, reject) => {
      const command = {
        commandName,
        payload: JSON.stringify(params),
      };
      const request = encodeURIComponent(JSON.stringify(command));
      try {
        const commandResult = await axios.get(request);
        if (commandResult.data.Code === "1") {
          resolve(JSON.parse(commandResult.data.Message));
        } else {
          await fetch(
            `SendEmail.aspx?Message=${commandResult.data.Message}&Request=${request}`
          );
          reject(new Error(commandResult.data.Message));
        }
      } catch (err) {
        await fetch(`SendEmail.aspx?Message=${err.message}&Request=${request}`);
        reject(err);
      }
    }),
};
